import ConfirmDialog from 'components/dialogs/ConfirmDialog';
import { useTranslation } from 'react-i18next';
import useModal from 'hooks/useModal';
import { InvoiceModel } from 'models/InvoiceModel';
import InvoicePaymentConfirmDialog from 'modules/invoices/dialogs/InvoicePaymentConfirmDialog';
import TopUpCreationDialog from 'modules/invoices/dialogs/TopUpCreationDialog';
import SimpleCreationDialog from 'modules/invoices/dialogs/SimpleCreationDialog';
import Api from 'utils/api';


const useInvoiceModals = () => {
    const {t} = useTranslation();
    const {showModal, hideModal} = useModal();

    const confirmDeleteInvoice = (invoice: InvoiceModel) => showModal(ConfirmDialog,
        {
            description: t('invoice_no_for', {number: invoice.number, payer: invoice.payer.name})
        },
        {
            title: t('confirm_delete_invoice'),
            fullScreen: false,
        })
        .then(() => Api.invoices.delete(invoice.id))
        .finally(hideModal);

    const openInvoiceConfirmationModal = (invoice: InvoiceModel, all: InvoiceModel[]) => showModal(InvoicePaymentConfirmDialog,
        {invoice, all},
        {
            title: t('confirm_payment'),
            maxWidth: 'xs',
            fullWidth: true,
        })
        .then(data => Api.invoices.confirm(data.ids, data.amount))
        .then(hideModal);

    const confirmRemoveFromInvoice = (description: string, type: string, id: number) => showModal(ConfirmDialog,
        {description},
        {
            title: t('confirm_remove_from_invoice', {value: type}),
            fullScreen: false,
        })
        .then(() => Api.invoices.removeItem(id))
        .finally(hideModal);

    const openTopUpInvoiceModal = () => showModal(TopUpCreationDialog,
        {},
        {
            title: t('add_title', {value: t('invoice_top_up')}),
            maxWidth: 'xs',
            fullWidth: true,
        })
        .then(data => Api.invoices.createTopUp(data.companyId, data.amount));

    const openSimpleInvoiceModal = () => showModal(SimpleCreationDialog,
        {},
        {
            title: t('add_title', {value: t('invoice_simple')}),
            maxWidth: 'md',
            fullWidth: true,
        })
        .then(Api.invoices.create);

    return {
        openInvoiceConfirmationModal,
        confirmDeleteInvoice,
        confirmRemoveFromInvoice,
        openTopUpInvoiceModal,
        openSimpleInvoiceModal,
    };
};

export default useInvoiceModals;
